import InfoBeneficialOwner from '../components/info-beneficial-owner';
export default InfoBeneficialOwner;
